import "./CheckEmailAccountRecovery.css";

const CheckEmailAccountRecovery = () => {
  return (
    <div className="check-email-account-recovery-container">
      <div>Account Recovery Email Sent!</div>
    </div>
  );
};

export default CheckEmailAccountRecovery;
